import { createGlobalStyle } from 'styled-components';
import { colors } from './colors';
export const GlobalStyles = createGlobalStyle `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    line-height: 1.6;
    color: ${colors.textPrimary};
    background-color: ${colors.backgroundPrimary};
  }

  /* App container */
  .app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .app-main {
    flex: 1;
  }

  /* Navigation styles */
  .legarta-navigation {
    border: none;
  }

  .legarta-navigation .navigation-item,
  .legarta-navigation .navigation-submenu {
    border: none;
  }

  .legarta-navigation .navigation-item:hover,
  .legarta-navigation .navigation-submenu:hover {
    border: none;
  }

  .legarta-navigation .navigation-item.active,
  .legarta-navigation .navigation-submenu.active {
    border: none;
  }

  /* Form styles */
  .contact-form .legarta-form-item label {
    font-weight: 500;
    color: ${colors.textPrimary};
  }

  .contact-form .legarta-input,
  .contact-form .legarta-textarea {
    border-radius: 8px;
    border: 1px solid ${colors.borderMedium};
    transition: all 0.3s ease;
  }

  .contact-form .legarta-input:focus,
  .contact-form .legarta-textarea:focus,
  .contact-form .legarta-input:hover,
  .contact-form .legarta-textarea:hover {
    border-color: ${colors.primary};
    box-shadow: 0 0 0 2px rgba(227, 30, 36, 0.1);
  }

  .submit-button {
    height: 48px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 16px;
  }

  /* Button styles */
  .legarta-button {
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.3s ease;
    outline: none !important;
  }

  .legarta-button:focus,
  .legarta-button:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }

  /* Убираем outline на всех кнопках */
  button {
    outline: none !important;
  }

  button:focus,
  button:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }

  /* Card styles */
  .legarta-card {
    border-radius: 12px;
    overflow: hidden;
  }

  /* Responsive utilities */
  @media (max-width: 768px) {
    .form-row {
      flex-direction: column;
    }
    
    .form-item-half {
      width: 100% !important;
    }
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${colors.backgroundLight};
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.borderDark};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${colors.borderMedium};
  }

  /* Focus styles */
  *:focus {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  /* Navigation focus styles - убираем outline, оставляем только подчеркивание */
  .legarta-navigation *:focus {
    outline: none;
    outline-offset: 0;
  }

  .legarta-navigation .navigation-item:focus,
  .legarta-navigation .navigation-submenu:focus {
    outline: none;
  }

  .legarta-navigation a:focus {
    outline: none;
  }

  /* Selection styles */
  ::selection {
    background: rgba(227, 30, 36, 0.2);
    color: ${colors.textPrimary};
  }
`;
